

export const ReadClients = () => import('./Clients/ClientsView');


export const ReadEntreprises = () => import('./Entreprises/EntreprisesView');


export const ReadFiles = () => import('./Files/FilesView');

export const ReadFonctions = () => import('./Fonctions/FonctionsView');


export const ReadHomes = () => import('./Homes/HomesView');

export const ReadInventaires = () => import('./Inventaires/ReadInventaires/ReadInventaires');

export const ReadLogins = () => import('./Logins/LoginsView');

export const ReadMaintenances = () => import('./Maintenances/MaintenancesView');

export const ReadMateriels = () => import('./Materiels/ReadMateriels/ReadMateriels');

export const ReadNationalites = () => import('./Nationalites/NationalitesView');

export const ReadPermissions = () => import('./Permissions/PermissionsView');

export const ReadPerms = () => import('./Perms/PermsView');


export const ReadProvinces = () => import('./Provinces/ProvincesView');
export const ReadRoles = () => import('./Roles/RolesView');


// export const ReadServices = () => import('./Services/ServicesView');

export const ReadSexes = () => import('./Sexes/SexesView');


export const ReadSitesglobals = () => import('./Sitesglobals/SitesglobalsView');

export const ReadSitespointeuses = () => import('./Sitespointeuses/SitespointeusesView');

export const ReadSitessdeplacements = () => import('./Sitessdeplacements/SitessdeplacementsView');


export const ReadSituations = () => import('./Situations/SituationsView');

export const ReadSoldables = () => import('./Soldables/SoldablesView');

export const ReadStatszones = () => import('./Statszones/StatszonesView');


export const ReadSurveillances = () => import('./Surveillances/SurveillancesView');



export const ReadTypeseffectifs = () => import('./Typeseffectifs/TypeseffectifsView');

export const ReadUsers = () => import('./Users/UsersView');


export const ReadVilles = () => import('./Villes/VillesView');


export const ReadZones = () => import('./Zones/ZonesView');


export const ReadSoustraitants = () => import('./Soustraitants/ReadSoustraitants/ReadSoustraitants');
export const ReadSites = () => import('./Sites/ReadSites/ReadSites');
export const CreateSites = () => import('./Sites/CreateSites/CreateSites');
export const EditSites = () => import('./Sites/EditSites/EditSites');

export const ReadFournitures = () => import('./Fournitures/ReadFournitures/ReadFournitures');
export const CreateFournitures = () => import('./Fournitures/CreateFournitures/CreateFournitures');
export const EditFournitures = () => import('./Fournitures/EditFournitures/EditFournitures');
export const ReadStocks = () => import('./Stocks/ReadStocks/ReadStocks');
export const CreateStocks = () => import('./Stocks/CreateStocks/CreateStocks');
export const EditStocks = () => import('./Stocks/EditStocks/EditStocks');

export const ReadMouvementsstocks = () => import('./Mouvementsstocks/ReadMouvementsstocks/ReadMouvementsstocks');
export const CreateMouvementsstocks = () => import('./Mouvementsstocks/CreateMouvementsstocks/CreateMouvementsstocks');
export const EditMouvementsstocks = () => import('./Mouvementsstocks/EditMouvementsstocks/EditMouvementsstocks');
export const ReadMouvementsstocksdetails = () => import('./Mouvementsstocksdetails/ReadMouvementsstocksdetails/ReadMouvementsstocksdetails');
export const CreateMouvementsstocksdetails = () => import('./Mouvementsstocksdetails/CreateMouvementsstocksdetails/CreateMouvementsstocksdetails');
export const EditMouvementsstocksdetails = () => import('./Mouvementsstocksdetails/EditMouvementsstocksdetails/EditMouvementsstocksdetails');
